import axios from 'axios'

const namespaced = true

const state = {
	templates: [],
}

const getters = {
	templates: state => { return state.templates },
	defaultTemplate: (state, getters, rootState, rootGetters) => {
		return state.templates.find(t => t.id === rootGetters['settings/defaultTemplate'])
	},
}

const actions = {
	GET_TEMPLATES({ commit }) {
		return new Promise((resolve, reject) => {
			axios.get('printtemplate')
			.then(({data}) => {
				commit('setTemplates', data)
				resolve(data)
			})
		})
	},

	ADD_TEMPLATE({ commit }, payload) {
		return new Promise((resolve, reject) => {
			axios.post('printtemplate', payload)
			.then(({data}) => {
				commit('addTemplate', data)
				resolve(data)
			})
		})
	},

	DELETE_TEMPLATE({ commit }, template_id) {
		return new Promise((resolve, reject) => {
			axios.delete('printtemplate/' + template_id)
			.then(response => {
				commit('removeTemplate', template_id)
				resolve()
			})
		})
	},
}

// mutations
const mutations = {
	setTemplates(state, templates) {
		state.templates = templates
	},

	addTemplate(state, template) {
		state.templates.unshift(template)
	},

	removeTemplate(state, template_id) {
		state.templates = state.templates.filter(t => t.id !== template_id)
	},
}

export default {
	namespaced,
	state,
	getters,
	actions,
	mutations
}